/* Small progressive enhancement of native Empire details/accordion menus. */
(() => {
  if (window.rhMegaMenuBound) return;
  window.rhMegaMenuBound = true;
  function bind(root = document) {
    const nav = root.querySelector('.site-navigation');
    if (!nav || nav.dataset.rhMegaBound) return;
    nav.dataset.rhMegaBound = 'true';
    const panels = [...nav.querySelectorAll('.navmenu-depth-1 > li > details')];
    let closeTimer;
    function setOpen(details, open) {
      details.open = open;
      details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(open));
      const panel = details.querySelector(':scope > [data-meganav-menu]');
      if (panel) {
        panel.dataset.animationState = open ? 'open' : 'closed';
        panel.removeAttribute('data-animation');
      }
    }
    function openOne(details) {
      clearTimeout(closeTimer);
      panels.forEach(other => setOpen(other, other === details));
    }
    function closeAll() {
      clearTimeout(closeTimer);
      panels.forEach(details => setOpen(details, false));
    }
    panels.forEach((details, index) => {
      const summary = details.querySelector(':scope > summary');
      const panel = details.querySelector(':scope > [data-meganav-menu]');
      if (panel) {
        panel.id = `rh-mega-panel-${index}`;
        summary.setAttribute('aria-controls', panel.id);
      }
      summary.addEventListener('click', event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        // Empire can open on pointer hover before the subsequent click.
        // A pointer click affirms that panel; keyboard activation can toggle.
        if (event.detail === 0 && details.open) setOpen(details, false);
        else openOne(details);
      }, true);
      // Preserve pointer crossing into the full-width panel without focus changes.
      details.addEventListener('pointerenter', () => clearTimeout(closeTimer));
      details.addEventListener('pointerleave', () => {
        closeTimer = setTimeout(() => {
          if (!details.contains(document.activeElement)) setOpen(details, false);
        }, 180);
      });
    });
    nav.addEventListener('keydown', event => {
      if (event.key !== 'Escape') return;
      const active = event.target.closest('details') || panels.find(d => d.open);
      if (!active) return;
      event.preventDefault();
      event.stopPropagation();
      closeAll();
      active.querySelector(':scope > summary')?.focus();
    });
    document.addEventListener('click', event => {
      if (!nav.contains(event.target)) closeAll();
    });
    document.addEventListener('focusin', event => {
      if (!nav.contains(event.target)) closeAll();
    });
    // Mobile retains Empire's native independently expandable accordion groups.
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => bind());
  else bind();
  document.addEventListener('shopify:section:load', event => bind(event.target));
})();
